
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-event-preview/[...slug]",
      function () {
        return require("private-next-pages/live-event-preview/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-event-preview/[...slug]"])
      });
    }
  